import ClientRegistrationApproval from '../../../components/Sales/ClientRegistration/ClientRegistrationApproval'
import React, { Component } from 'react'
import ClientsApi from '../../../api/Sales/Clients'
import { withRouter } from 'react-router-dom'
import { pick } from 'lodash'
import { message, notification } from 'antd'
import MembersApi from '../../../api/Members'
import BanksApi from '../../../api/Banks'
import DocumentsApi from '../../../api/Documents'

class ClientRegistrationApprovalCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      fetching: false,
      current: 0,
      fetchingSupplier: false,
      listExist: [],
      lastActionIsNext: true,
      memberType: null,
      bankType: null,
      RepType: null,
      member: null,
      bank: null,
      rep: null,
    }
  }

  api = new ClientsApi()
  membersApi = new MembersApi()
  banksApi = new BanksApi()
  docsApi = new DocumentsApi()

  key = this.props.match.params.key
  memberRef = React.createRef()
  bankRef = React.createRef()
  refRef = React.createRef()
  refAccountRef = React.createRef()
  refLogisticRef = React.createRef()

  contractRef = React.createRef()

  async componentDidMount() {
    await this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })

      const list = await this.api.registrations.get(this.key)
      const members = await this.membersApi.organisationFull()
      const reps = await this.membersApi.individual()

      let listExist = {
        members,
        banks: {},
        reps,
      }

      console.log(listExist)

      this.setState({ list, listExist, fetching: false })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }

  fetchBank = async (owner) => {
    this.setState({ fetching: true })
    const banks = await this.banksApi.list(owner)
    let listExist = this.state.listExist
    listExist.banks = banks
    this.setState({ banks, listExist, fetching: false })
  }

  next = async () => {
    // same index as in SupplierRegistrationForm steps deceleration
    try {
      if (this.state.current === 1) {
        const formMember = await this.checkForm(this.memberRef)
        // console.log(formMember)
        this.setState({ formMember })
      }

      if (this.state.current === 2) {
        const contractRep = await this.checkForm(this.contractRef)
        // console.log(contractRep)
        this.setState({ contractRep })
      }

      if (this.state.current === 4) {
        const formRep = await this.checkForm(this.refRef)
        // console.log(formRep)
        this.setState({ formRep })
      }

      if (this.state.current === 6) {
        const formAccRep = await this.checkForm(this.refAccountRef)
        // console.log(formAccRep)
        this.setState({ formAccRep })
      }

      if (this.state.current === 8) {
        const formLogisticRep = await this.checkForm(this.refLogisticRef)
        // console.log(formLogisticRep)
        this.setState({ formLogisticRep })
      }
    } catch (e) {}

    const current = this.state.current + 1
    this.setState({ current, lastActionIsNext: true })
  }

  skip = () => {
    const current = this.state.current + 2
    this.setState({ current })
  }
  prev = () => {
    // if (this.state.current === 1) {
    //   this.setState({ member: null })
    // }
    //
    // if (this.state.current === 3) {
    //   this.setState({ bank: null })
    // }
    //
    // if (this.state.current === 5) {
    //   this.setState({ rep: null })
    // }

    const current = this.state.current - 1
    this.setState({ current, lastActionIsNext: false })
  }

  setMember = (member, type) => {
    this.setState({ member, memberType: type })
  }

  setRep = (rep, type) => {
    switch (type) {
      case 'representative':
        console.log('setRep', { type, rep })
        this.setState({ rep, RepType: type })
        break
      case 'accounts':
        console.log('setRep', { type, rep })
        this.setState({ accountsRep: rep, RepType: type })
        break
      case 'logistics':
        console.log('setRep', { type, rep })
        this.setState({ logisticsRep: rep, RepType: type })
        break
    }
  }

  setSameRep = (rep, type) => {
    switch (type) {
      case 'representative':
        console.log('setSameRep representative', { type, rep })
        this.setState({ rep, RepType: type })
        break
      case 'accounts':
        console.log('setSameRep accounts', { type, rep })
        this.setState({ accountsSameRep: rep, RepType: type })
        break
      case 'logistics':
        console.log('setSameRep logistics', { type, rep })
        this.setState({ logisticsSameRep: rep, RepType: type })
        break
    }
  }

  getData = () => {
    const dataEditedMember = this.state.formMember
    const dataEditedRep = this.state.formRep
    const dataEditedAccRep = this.state.accountsSameRep
      ? { accountsRep: this.state.accountsSameRep }
      : this.state.formAccRep

    const dataEditedLogisticRep = this.state.logisticsSameRep
      ? { logisticsRep: this.state.logisticsSameRep }
      : this.state.formLogisticRep

    const dataEditedContract = this.state.formRep

    // data from form
    let dataEdited = {
      ...dataEditedMember,
      ...dataEditedRep,
      ...dataEditedContract,
      ...dataEditedAccRep,
      ...dataEditedLogisticRep,
    }

    console.log()

    dataEdited.business = {
      ...dataEditedMember.business,
      ...dataEditedContract.business,
    }

    let dataExist = {
      member: this.state.member,
      bank: this.state.bank,
      rep: this.state.rep,
      accountsRep: this.state.accountsRep,
      logisticsRep: this.state.logisticsRep,
    }
    // sent data
    return {
      dataExist,
      dataEdited,
      id: this.state.list._key,
    }
  }

  approve = async () => {
    try {
      this.setState({
        approving: true,
      })

      const data = this.getData()
      const res = await this.api.registrations.approve(data)
      const profileID = res.owner.split('/')[1]

      this.props.history.push(`/clients/${profileID}`)
      notification['info']({
        message: 'Please Create The Contract',
        description:
          'The Account has not been created, you have to do it manually, ' +
          'Please press "+ New" Button in Accounts Tab',
        duration: 10,
      })
      this.setState({
        approving: false,
      })
      message.success('Approved !')
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        approving: false,
      })
    }
  }

  checkForm = (currentRef) => {
    return new Promise((res, rej) => {
      currentRef.current.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  render() {
    return (
      <ClientRegistrationApproval
        {...this.state}
        {...pick(this, [
          'onCancel',
          'onEdit',
          'submit',
          'update',
          'remove',
          'fetch',
          'skip',
          'checkForm',
          'approve',
          'handleOps',
          'refAccountRef',
          'refLogisticRef',
          'setSameRep',
          'next',
          'prev',
          'setMember',
          'setBank',
          'setRep',
          'memberRef',
          'refRef',
          'contractRef',
          'getData',
          'fetchBank',
        ])}
      />
    )
  }
}

export default withRouter(ClientRegistrationApprovalCont)
